import Vue from 'vue'
import $ from 'jquery'
import { components } from '../data/cpts/components.js'
import { snapping } from './snapping.js'
import { cloneDeep } from 'lodash'

const ID_PANZOOM = '#pan-zoom-canvas'
const ID_CANVAS = '#canvas'
const CN_VIEWPORT = '.svg-pan-zoom_viewport'
const CN_DRAGGABLE = '.draggable'

function getTranslateXY(element) {
  const style = window.getComputedStyle(element)
  const matrix = new DOMMatrixReadOnly(style.transform)

  // const panzoom = document.querySelector(CN_VIEWPORT)
  // const panzoombox = panzoom.getClientRects()
  // const _box = panzoombox.item(0)
  // _box.
  // const CTM = panzoom.getScreenCTM()
  // const pos = {
  //   x: (matrix.m41 - CTM.e) / CTM.a,
  //   y: (matrix.m42 - CTM.f) / CTM.d
  // }
  const pos = {
      x: matrix.m41,
      y: matrix.m42
  }
  // const box = element.getBBox()
  return pos
  // return {
  //   x: pos.x - (box.x + box.width / 2),
  //   y: pos.y - (box.y + box.height / 2)
  // }
  // return {
  //     x: matrix.m41,
  //     y: matrix.m42
  // }
}

// for loading rotate state from store... (maybe later)
// const setSavedCanvasMatrix = function (canvas, el) {
//   const matrix = el.getAttribute('transform')
//   const transform = canvas.createSVGTransform()
//   let sm = matrix.split(' ')
//   if (sm.length === 1) sm = matrix.split(',')
//   const sx = Number(sm[4])
//   const sy = Number(sm[5].replace(')', ''))
//   const m1 = canvas.createSVGMatrix()
//   let m2 = m1.translate(sx, sy)
//   let deg = 0
//   if (sm[1] === '1' && sm[2] === '-1' && sm[3] === '0') {
//     deg = 90
//   } else if (sm[1] === '1' && sm[2] === '-1' && sm[3] === '-1') {
//     deg = 180
//   } else if (sm[1] === '-1' && sm[2] === '1' && sm[3] === '0') {
//     deg = 270
//   }

//   if (Number(sm[3]) === 0) sm[3] = 1
//   m2 = m2.scale(Number(sm[3])).rotate(deg)
//   // m2 = m2.rotate(deg)
//   transform.setMatrix(m2)
//   el.transform.baseVal.initialize(transform)
// }

const getMousePosition = function (e) {
  const panzoom = document.querySelector(CN_VIEWPORT)
  const pt = { x: 0, y: 0 }
  const CTM = panzoom.getScreenCTM()
  pt.x = (e.clientX - CTM.e) / CTM.a
  pt.y = (e.clientY - CTM.f) / CTM.d
  return pt
}

export const elct = {
  mixins: [snapping],
  data () {
    return {
      canvas: null,
      panzoom: null,
      dg: null,
      currentElct: {
        el: null,
        idname: '',
        type: '',
        box: null,
        qsx: 0, // quickSetter x object
        qsy: 0, // quickSetter y object
        status: null,
        sx: 0,
        sy: 0,
        isBreadboard: false,
        isSnapped: false
      },
      mouse: {
        target: null,
        x: 0,
        y: 0
      },
      info: null
    }
  },
  mounted () {
    this.canvas = this.$refs.pan_zoom_canvas.$el.querySelector(ID_CANVAS)
    this.panzoom = this.canvas.querySelector(CN_VIEWPORT)
  },
  computed: {
    notBreadBoard () {
      return !this.currentElct.isBreadboard && (this.currentElct.type === 'part' || this.currentElct.type === 'sensor')
    }
  },
  methods: {
    getComponentIdByName (name) {
      const obj = components.findByIdName(name)
      if (!obj) return null
      return obj.id
    },
    getComponentClassById (id) {
      const obj = components.find('idname', id)
      if (!obj) return null
      this.info = obj
      const Object = require(`../components/elct/cpts/${obj.type}/${obj.idname}.vue`).default
      return Vue.extend(Object)
    },
    getComponentElementById (compClassId, pos = { x: 0, y: 0 }, vm = this, mode = 'create', _compId = '') {
      const ComponentClass = vm.getComponentClassById(compClassId)
      if (ComponentClass === null) return
      if (vm.$store.state.elct.usingCounts[vm.info.idname].limit === 0) {
        return
      }

      // const cnt = vm.$store.state.elct.usingCounts[vm.info.idname].totaluse
      // const id = `${vm.info.idname}_${cnt}`

      let id = _compId
      if (mode === 'create') {
        for (let i = 0; i < vm.$store.state.elct.usingCounts[vm.info.idname].seats.length; i++) {
          const element = vm.$store.state.elct.usingCounts[vm.info.idname].seats[i];
          if (!element.taken) {
            id = element.name
            break
          }
        }
      }
      if (!id) {
        console.error('mixins/elct: failed to assign compo id...', _compId)
        return
      }

      const code = vm.info.code
      const instance = new ComponentClass({
        parent: vm,
        propsData: { data: { id, code } }
      })
      instance.$mount()
      instance.$el.id = id
      vm.info.type !== 'tool' ? instance.$el.classList.add('part') : instance.$el.classList.add(`${vm.info.type}`)
      instance.$el.classList.add('draggable')
      instance.$el.setAttribute('x', pos.x)
      instance.$el.setAttribute('y', pos.x)

      return instance.$el
    },
    setCurrentElement (el, vm = this) {
      vm.currentElct.el = el
      
      const idx = vm.currentElct.el.id.indexOf('_')
      const idname = vm.currentElct.el.id.substr(0, idx)
      const obj = components.find('idname', idname)
      vm.info = obj

      vm.currentElct.idname = vm.info.idname
      vm.currentElct.type = vm.info.type
      vm.currentElct.isBreadboard = el.id.includes('Breadboard')
      if (vm.currentElct.isBreadboard) {
        vm.activate.el = vm.currentElct.el
      }
    },
    createElctComponent (compClassId, mode = 'create', pos = { x: 0, y: 0 }, vm = this, _compId = '') {
      // console.log('mixins/elct/createElctComponent', compClassId)

      if (vm.$store.state.isSimulating) return
      
      const obj = components.find('idname', compClassId)
      if (!obj) return console.error('mixins/elct/createElctComponent: failed to create element')
      vm.info = obj

      let el = null
      if (mode === 'create') {
        el = vm.getComponentElementById(compClassId, pos, vm)
      } else {
        el = vm.getComponentElementById(compClassId, pos, vm, mode, _compId)
      }

      if (!el) {
        console.error('mixins/elct/createElctComponent: failed to create element')
        return
      }
      vm.setCurrentElement(el)
      const mouse = getMousePosition(window.event)
      const box = vm.currentElct.el.getBBox()
      mouse.x -= (box.x + box.width / 2)
      mouse.y -= (box.y + box.height / 2)
      vm.panzoom.appendChild(vm.currentElct.el)

      if (mode === 'load') {
        vm.currentElct.el.setAttribute('x', pos.x + 'px')
        vm.currentElct.el.setAttribute('y', pos.y + 'px')
        vm.currentElct.el.setAttribute('transform', `translate(${pos.x},${pos.y})`)

        if (vm.notBreadBoard) {
          vm.currentElct.isSnapped = vm.isSnapped(vm.currentElct.el)
          if (vm.currentElct.isSnapped) vm.snapEnd(vm.currentElct.el)
        }

        vm.currentElct.status = 'loaded'
      } else {
        vm.currentElct.el.setAttribute('x', mouse.x + 'px')
        vm.currentElct.el.setAttribute('y', mouse.y + 'px')
        vm.initElctMouseTracking(vm.currentElct.el)
        vm.currentElct.status = 'created'
      }
      vm.appendElctToCanvas()
      vm.selectElctEvent(vm)
      vm.addElctDrageEvent()
    },
    appendElctToCanvas (vm = this) {
      if (!vm.currentElct.el) return
      const elct = vm.currentElct
      if (elct.idname === 'Breadboard') {
        vm.panzoom.insertBefore(elct.el, vm.panzoom.firstChild)
      } else {
        const w = vm.panzoom.querySelectorAll('.wire-group')[0]
        if (w) {
          vm.panzoom.insertBefore(elct.el, w)
        } else {
          vm.panzoom.appendChild(elct.el)
        }
      }
    },
    trackingHandler (evt) {
      if (this.currentElct.el) {
        this.mouse = getMousePosition(evt)
        this.mouse.x -= (this.currentElct.box.x + this.currentElct.box.width / 2)
        this.mouse.y -= (this.currentElct.box.y + this.currentElct.box.height / 2)
      } else {
        console.error('[elct.js, trackingHandler] There is no currentElct element.')
      }
    },
    trackingUpdate () {
      this.currentElct.qsx(this.mouse.x)
      this.currentElct.qsy(this.mouse.y)
    },
    initElctMouseTracking (el) {
      this.currentElct.box = el.getBBox()
      this.currentElct.qsx = window.gsap.quickSetter(el, 'x', 'px')
      this.currentElct.qsy = window.gsap.quickSetter(el, 'y', 'px')

      /* add mouse move EventListener : start mouse tracking with elct component */
      this.canvas.addEventListener('mousemove', this.trackingHandler)
      window.gsap.ticker.add(this.trackingUpdate)

      this.currentElct.status = 'dragging'
      /* remove mouse click EventLisener :
      end mouse tracking and then elct component is putted on the panzoom canvas */
      this.canvas.addEventListener('click', e => {
        e.stopPropagation()
        e.preventDefault()
        this.currentElct.el.setAttribute('transform', `translate(${this.mouse.x},${this.mouse.y})`)
        this.appendElctToCanvas()
        this.canvas.removeEventListener('mousemove', this.trackingHandler)
        window.gsap.ticker.remove(this.trackingUpdate)
        // console.log('모듈 이벤트')
        // console.log(this.currentElct)
        if (this.notBreadBoard) {
          this.currentElct.isSnapped = this.isSnapped(this.currentElct.el)
          if (this.currentElct.isSnapped) this.snapEnd(this.currentElct.el)
        }
        
        // store using elct data after finished el setting.
        this.$store.commit('elct/addUsingElct', {
          el: this.currentElct.el,
          id: this.currentElct.el.id,
          idname: this.currentElct.idname,
          name: this.info.code.name,
          pos: {
            x: this.mouse.x,
            y: this.mouse.y
          },
          resist: this.currentElct.type === 'Resistor' ? 330 : 0
        })
        this.$store.commit('elct/putElctOnVisited', this.currentElct.el.id)

        this.currentElct.el = this.currentElct.box = null
        this.currentElct.status = 'on-cavnas'
      }, { once: true })
    },
    addElctDrageEvent () {
      const vm = this
      let elcts = null
      var dg = window.Draggable.create(CN_DRAGGABLE, {
        bounds: ID_PANZOOM,
        onDragStart: function () {
          window.event.stopPropagation()
          window.event.preventDefault()
          vm.currentElct.el = this.target
          vm.currentElct.isBreadboard = this.target.id.includes('Breadboard')
          vm.currentElct.type = this.target.classList[0]
          if (vm.currentElct.isBreadboard) {
            vm.activate.el = this.target
            vm.activate.dg = dg.filter((e) => {
              return vm.currentElct.el.id === e.target.id
            })[0]
            elcts = vm.findSnappedElctAll()
          }
        },
        onDrag: function () {
          vm.currentElct.status = 'dragging'
          if (vm.notBreadBoard) {
            vm.currentElct.isSnapped = vm.isSnapped(vm.currentElct.el)
          } else if (vm.currentElct.isBreadboard) {
            if (elcts.length > 0) vm.snapDrag(elcts)
          }
          if (vm.$store.state.wire.wireList) vm.$store.commit('wire/updateLines')
        },
        onDragEnd: function () {
          vm.updatePosFromMouseToStore(vm, getTranslateXY(vm.currentElct.el))

          vm.currentElct.status = ''
          if (vm.notBreadBoard) {
            const e = $(this.target).closest('.part')[0]
            if (vm.currentElct.isSnapped) e.classList.add('snapping')
            else e.classList.remove('snapping')
          }
          if (vm.currentElct.isBreadboard) {
            // vm.activate.el = vm.activate.dg = null
            const snappedKeys = Object.keys(vm.snapped.elct)
            // console.log('mixins/elct/onDragEnd BB snapped:', vm.snapped.elct)
            for (let i = 0; i < snappedKeys.length; i++) {
              const elctname = snappedKeys[i];
              // console.log(vm.currentElct.el.id, elctname)
              if(vm.currentElct.el.id === elctname) {
                vm.snapped.elct[elctname].forEach(snappedelctEl => {
                  const el = snappedelctEl
                  const pos = getTranslateXY(el)
                  const codeid = components.convertIdToCode(el.id)
                  const obj = {
                    id: el.id,
                    code: codeid.substring(0, codeid.indexOf('-')),
                    attr: 'pos',
                    val: {
                      x: pos.x,
                      y: pos.y
                    }
                  }
                  // console.log('mixins/elct/onDragEnd BB snapped obj pos update:', obj)
                  vm.$store.commit('elct/updateElctValues', obj)
                });
              }
            }
          }
          vm.snapEnd()
          vm.$store.commit('elct/updateElctsValues')
        }
      })
    },
    selectElctEvent (vm = this) {
      vm.currentElct.el.addEventListener('click', (e) => {
        if (vm.$store.state.isSimulating ||
          vm.currentElct.status === 'created' ||
          vm.currentElct.status === 'dragging') return
          
        // console.log('ElctEvent Click', vm.currentElct)

        const el = $(e.target).closest(CN_DRAGGABLE)[0]
        vm.currentElct.isBreadboard = el.id.startsWith('Breadboard')
        if (vm.currentElct.isBreadboard) {
          vm.$store.commit('elct/selectConnectedWires', el.id)
          vm.$store.commit('elct/setConnectedStyle', true)
          vm.snapEnd()
        } else {
          vm.$store.commit('elct/selectConnectedWires', el.id)
          vm.$store.commit('elct/setConnectedStyle', false)
        }
      })
    },
    removeElctAll () {
      this.$store.commit('elct/deleteSelectedAll')
      this.snapEnd()
    },
    updateElementPosition (componame, pos, vm = this) {
      const el = vm.panzoom.querySelector(`#${componame}`)
      el.setAttribute('transform', `translate(${pos.x},${pos.y})`)

      const idx = componame.indexOf('_')
      const idname = componame.substr(0, idx)
      const obj = components.find('idname', idname)
      if (!obj) {
        console.log('failed updateElementPosition', componame)
        return
      }
      vm.info = obj
      vm.setCurrentElement(el)
      vm.snapEnd()
    },
    updatePosFromMouseToStore (vm = this, pos) {
      try {
        // console.log('component info:', vm.currentElct.el.id)
        const codeid = components.convertIdToCode(vm.currentElct.el.id)
        const obj = {
          id: vm.currentElct.el.id,
          code: codeid.substring(0, codeid.indexOf('-')),
          attr: 'pos',
          val: {
            x: pos.x,
            y: pos.y
          }
        }
        // console.log('updatePosFromMouseToStore', obj)
        vm.$store.commit('elct/updateElctValues', obj)
      } catch (error) {
        console.warn(error)
      }
    },
    removeElctComponent (compId, vm = this) {
      const el = $(`g#${compId}`)[0]
      // console.log(el)
      vm.setCurrentElement(el)
      if (el) {
        vm.$store.commit('elct/deleteFromRootVue', compId)
        el.remove()
        vm.$store.commit('elct/clearSelectedElctList')
        // console.log('activate', vm.activate)
        vm.snapEnd()
      }  
    }
  }
}
